import { useQuery } from '@tanstack/react-query';
import { getMariaChatToken, MARIA_TOKEN_QUERY_KEY } from '../services/maria';

export const useMariaToken = (userId?: number, companyId?: number) => {
  return useQuery<{ token: string; businessId: string }>({
    queryKey: [...MARIA_TOKEN_QUERY_KEY, userId, companyId],
    queryFn: () => getMariaChatToken(companyId!).then((r) => r.data),
    enabled: !!userId && !!companyId,
    staleTime: 55 * 60 * 1000,
  });
};
